module.exports = __webpack_public_path__ + "static/media/beer.3db146b2.svg";